import { H1 } from '@montel/montelpro-shared-components-v2';
import { EditDefaultProviderBlacklist } from './EditDefaultProviderBlacklist';
import DefaultProviderBlacklistContextProvider from './DefaultProviderBlacklistContext';

const DefaultProviderBlacklistContent: React.FC = () => (
	<>
		<H1>Default Provider Blacklist</H1>
		<EditDefaultProviderBlacklist />
	</>
);

export const DefaultProviderBlacklist: React.FC = () => (
	<DefaultProviderBlacklistContextProvider>
		<DefaultProviderBlacklistContent />
	</DefaultProviderBlacklistContextProvider>
);
